import React from 'react';
import { withRouter } from 'react-router';
import Api from '../../api/api';
import LoginActions from '../../actions/login-actions';
import LoginStore from '../../stores/login-store';
import AppRoutes from '../../routes/routes';
import Loading from '../loading/loading';

class MarketingRegister extends React.Component {
    constructor(props) {
        super(props);
        this._onChange = this._onChange.bind(this);
        this.state = {
            error: false,
            error_messages: [],
            loading: false,
            email_valid: true,
            email_error: false
        };
        this.captcha = Api.captcha();
    }

    componentDidMount() {
        LoginStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        LoginStore.removeChangeListener(this._onChange);
    }

    validateInput(data) {
        var error_messages = [];

        if (data.password !== data.rePassword) {
            error_messages.push('The Passwords you entered do not match');
        }

        if (!this.state.email_valid) {
            error_messages.push('The email you entered is invalid. Reason: ' + this.state.email_reason);
        }

        if (+data.captcha !== this.captcha.result) {
            error_messages.push("Your answer was incorrect please try again");
        }

        for (var key in data) {
            if (!data[key].length) {
                error_messages.push('Please fill in all fields correct');
                break;
            }
        }

        return error_messages;
    }

    parseSeverResponse(data) {
        var error_messages = [];

        if (typeof (data) === 'string') {
            error_messages.push(data);
        } else {
            for (var key in data) {
                if (!Object.prototype.hasOwnProperty.call(data, key)) {
                    continue;
                }

                if (Array.isArray(data[key])) {
                    data[key].forEach(msg => error_messages.push(`${key} ${msg}`))
                } else {
                    error_messages.push(data[key])
                }
            }
        }

        return error_messages;
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ loading: true });

        const data = {
            name: this.refs.name.value,
            email: this.refs.email.value,
            password: this.refs.password.value,
            rePassword: this.refs.passwordConfirmation.value
        };
        const captcha = this.refs.captcha.value;

        let error_messages = this.validateInput(Object.assign({}, data, { captcha }));
        if (error_messages.length) {
            this.setState({
                loading: false,
                error: true,
                error_messages
            });
        } else {
            LoginActions.register(data);
        }
    }

    _checkEmail() {
        if (this.state.timeout) {
            clearTimeout(this.state.timeout);
        }

        var email = this.refs.email.value;
        var headers = this.props.userApiRequest;

        var timeout = setTimeout(function () {
            Api.validateEmail(email, headers, {
                onSuccess: (res) => {
                    this.setState({
                        email_valid: res.data.is_valid,
                        email_reason: res.data.reason,
                    });
                },
                onError: (res) => {
                    this.setState({
                        email_valid: true,
                        email_reason: false
                    });
                },
            });
        }.bind(this), 500);

        this.setState({ timeout: timeout });
    }

    _onChange() {
        if (!LoginStore.errors) {
            return;
        }

        this.setState({
            loading: false,
            error: true,
            error_messages: this.parseSeverResponse(LoginStore.errors)
        });
    }

    render() {
        return (
            <div className="marketing-auth-block" style={{ padding: '36px 32px' }}>
                {(this.state.loading) ? <Loading text="Please wait..." /> : null}

                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '28px', color: 'var(--heading)', fontWeight: 400, marginBottom: '8px' }}>Create an Account</h2>
                    <p style={{ fontSize: '14px', color: 'var(--muted)' }}>For full access to the hand-curated data at Neurochecklists</p>
                </div>

                <form onSubmit={this.handleSubmit.bind(this)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                    {
                        (this.state.error) ? (
                            <div className="alert alert-danger" style={{ background: 'var(--red-50)', color: 'var(--red-400)', padding: '12px 16px', borderRadius: '8px', borderLeft: '3px solid var(--red-400)', fontSize: '13.5px' }}>
                                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                    {this.state.error_messages.map((item, index) => <li key={index}>{item}</li>)}
                                </ul>
                            </div>
                        ) : null
                    }

                    <div className="input-group">
                        <label className="input-label" htmlFor="f_name">Name <span style={{ color: 'var(--red-400)' }}>*</span></label>
                        <input className="input-field" id="f_name" type="text" ref="name" name="name" autoComplete="name" required placeholder="Dr. Jane Doe" />
                    </div>

                    <div className="input-group">
                        <label className="input-label" htmlFor="email">Email <span style={{ color: 'var(--red-400)' }}>*</span></label>
                        <input className="input-field" id="email" type="email" ref="email" name="email" autoComplete="email" required onChange={this._checkEmail.bind(this)} placeholder="doctor@hospital.com" />
                    </div>

                    <div className="input-group">
                        <label className="input-label" htmlFor="password">Password <span style={{ color: 'var(--red-400)' }}>*</span></label>
                        <input className="input-field" id="password" type="password" ref="password" name="password" required placeholder="••••••••" />
                    </div>

                    <div className="input-group">
                        <label className="input-label" htmlFor="password-confirmation">Confirm Password <span style={{ color: 'var(--red-400)' }}>*</span></label>
                        <input className="input-field" id="password-confirmation" type="password" ref="passwordConfirmation" name="password-confirmation" required placeholder="••••••••" />
                    </div>

                    <div style={{ fontSize: '13.5px', color: 'var(--body)' }}>
                        <label style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', cursor: 'pointer' }}>
                            <input id="privacy" type="checkbox" ref="privacy" required style={{ marginTop: '5px' }} />
                            <span style={{ lineHeight: 1.5 }}>I agree to the <a href={AppRoutes.tcs} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue-600)', textDecoration: 'none' }}>Terms and Conditions</a>, <a href={AppRoutes.privacy} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue-600)', textDecoration: 'none' }}>Privacy Policy</a>, and <a href={AppRoutes.data} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue-600)', textDecoration: 'none' }}>Personal Data Policy</a>. <span style={{ color: 'var(--red-400)' }}>*</span></span>
                        </label>
                    </div>

                    <div className="input-group">
                        <label className="input-label" htmlFor="captcha">What is the sum of {this.captcha.leftside} + {this.captcha.rightside}? <span style={{ color: 'var(--red-400)' }}>*</span></label>
                        <input className="input-field" id="captcha" type="text" ref="captcha" required placeholder="Your answer" />
                    </div>

                    <div style={{ marginTop: '8px' }}>
                        <button type="submit" className="btn btn-primary-sm" style={{ width: '100%', padding: '14px', fontSize: '15px', textAlign: 'center' }}>
                            <span style={{ color: 'var(--white)' }}>Sign Up</span>
                        </button>
                    </div>

                </form>
            </div>
        );
    }
}

export default withRouter(MarketingRegister);
